import { render, staticRenderFns } from "./EvaluacionRelatorData.vue?vue&type=template&id=0eb70e0a&"
import script from "./EvaluacionRelatorData.vue?vue&type=script&lang=js&"
export * from "./EvaluacionRelatorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports